import { generateUtilityClass, generateUtilityClasses, unstable_composeClasses as composeClasses } from '@mui/material';

export function getDialogHeaderUtilityClass(slot: string) {
  return generateUtilityClass('O2DialogHeader', slot);
}

const dialogHeaderClasses = generateUtilityClasses('O2DialogHeader', [
  'root',
  'titlesWrapper',
  'title',
  'subTitle',
  'closeBtnWrapper',
  'closeBtn',
]);

export const useDialogHeaderUtilityClasses = (classes?: Record<string, string>) => {
  return composeClasses(
    {
      root: ['root'],
      titlesWrapper: ['titlesWrapper'],
      title: ['title'],
      subTitle: ['subTitle'],
      closeBtnWrapper: ['closeBtnWrapper'],
      closeBtn: ['closeBtn'],
    },
    getDialogHeaderUtilityClass,
    classes
  );
};

export default dialogHeaderClasses;
